enum ConductorEventsEnum {
	Init = 'runner.init',
	Loaded = 'runner.load',
	Start = 'runner.start',
	Error = 'runner.error',
}

export default ConductorEventsEnum;
